/**
 * @desc 平台支付状态查询接口
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {}

export const init = new defs.SimpleResponse()

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/payment/payQuery',
    data: params,
    method: 'post',
  })
}
